import InsightsTooltip from 'components/ReusableComponents/Charts/Inslghts/InsightsTooltip'
import CloseIcon from 'components/ReusableComponents/CloseIcon'
import Dialog from 'components/ReusableComponents/Dialog'
import SmartDatepicker from 'components/ReusableComponents/SmartDatepicker'
import {
  dialogFlowIntentNames,
  goodDialogFromIntents
} from 'features/Engagement/constants'
import moment from 'moment'
import { useEffect, useState } from 'react'
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts'
import engagementApi from 'services/api/engagement'

import styles from './MessagesByTopicDialog.module.module.scss'

const colors = [
  '#10B981',
  '#A855F7',
  '#84CC16',
  '#EC4899',
  '#F43F5E',
  '#22C55E',
  '#0EA5E9',
  '#EF4444'
]

const MessagesByTopic = ({
  onCloseClick,
  hotelIds,
  startDate,
  endDate,
  setStartDate,
  setEndDate
}) => {
  const [topics, setTopics] = useState()

  const [chartData, setChartData] = useState()

  useEffect(() => {
    engagementApi
      .topicDetails({
        subsidiaryIds: hotelIds,
        fromDate: startDate.format('YYYY-MM-DD'),
        toDate: endDate.format('YYYY-MM-DD')
      })
      .then(data => {
        const topics = Object.values(data)[0]
          .filter(d => goodDialogFromIntents.includes(d.topic))
          .map(d => dialogFlowIntentNames[d.topic])

        setTopics(topics)

        const graphData = Object.keys(data).map(date => ({
          name: moment(date).format('MMM D'),
          ...data[date].reduce(
            (prev, curr) => ({
              ...prev,
              [dialogFlowIntentNames[curr.topic]]: curr.topicCount
            }),
            {}
          )
        }))

        setChartData(graphData)
      })
  }, [startDate, endDate, hotelIds])

  if (!chartData) {
    return null
  }

  return (
    <Dialog>
      <div className={styles.wrapper}>
        <div className={styles.header}>
          <h2 className={styles.dialogTitle}>Messages by topic</h2>
          <SmartDatepicker
            localstorageName="performance-reports"
            startDate={startDate}
            endDate={endDate}
            onChangeStartDate={setStartDate}
            onChangeEndDate={setEndDate}
          />
          <button onClick={onCloseClick} className={styles.closeButton}>
            <CloseIcon />
          </button>
        </div>
        <div className={styles.content}>
          <div className={styles.graphHolder}>
            <p className={styles.chartLabel}>Messages</p>
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                width="100%"
                height={250}
                data={chartData.slice(0, 10)}
                margin={{
                  top: 0,
                  right: 0,
                  left: 0,
                  bottom: 15
                }}
              >
                <CartesianGrid stroke="#F2F2F2" vertical={false} />
                <XAxis
                  dataKey="name"
                  axisLine={{ stroke: '#F2F2F2', strokeWidth: 1 }}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(0, 14)'
                  }}
                  tickSize={0}
                  padding={{ top: 30, bottom: 20, right: 40 }}
                />
                <YAxis
                  tickSize={0}
                  axisLine={false}
                  tick={{
                    fill: '#7D7D7D',
                    fontSize: 12,
                    transform: 'translate(-10, 0)'
                  }}
                  domain={['dataMin', 'dataMax']}
                  padding={{ top: 40, bottom: 0 }}
                />
                <Tooltip
                  content={<InsightsTooltip />}
                  cursor={{
                    stroke: 'red',
                    strokeWidth: 0,
                    fill: '#dedede',
                    opacity: 0.22
                  }}
                />
                {topics.map((name, i) => (
                  <Line
                    type="monotone"
                    dataKey={name}
                    stroke={colors[i]}
                    activeDot={{ r: 8 }}
                    strokeWidth={2}
                    dot={false}
                    isUpdateAnimationActive={false}
                    isAnimationActive={false}
                  />
                ))}
              </LineChart>
            </ResponsiveContainer>
          </div>
          <div className={styles.legends}>
            {topics.map((name, i) => (
              <div className={styles.legend}>
                <svg width={14} height={14}>
                  <rect width={14} height={14} fill={colors[i]} />
                </svg>
                <span>{name}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default MessagesByTopic
